<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="车牌号">
              {{ formData.vehicleKey || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机姓名">
              {{ formData.driverName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机身份证">
              {{ formData.driverKey || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机手机号">
              {{ formData.driverMobile || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              {{ formData.remark || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">返回</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'VehicleBlackDetail',
  data() {
    return {
      formData: {
        blacklistId: '',
        vehicleKey: '',
        driverName: '',
        driverKey: '',
        driverMobile: '',
        remark: ''
      }
    }
  },
  computed: {
    blacklistId() {
      return this.$route.query.blacklistId
    }
  },
  created() {
    if (this.blacklistId) {
      this.loadDetails()
    }
  },
  methods: {
    loadDetails() {
      this.$axios.get(this.$apis.vehicleBlack.selectWlVehicleBlacklistByBlacklistId, {
        params: { blacklistId: this.blacklistId }
      }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-select,
.el-input,
.el-cascader {
  width: 95%;
}
</style>
